import React, { Component } from "react";
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sdkclaro from "@claro/sdkclaromicrofront";
import { getFavoritosRef, deleteFavoritesRef,getMessagesFavoritesServices } from '../../../store/actions/favoritosRef.js';
import CreateFavoriteService from "../../molecules/createFavoriteService";
import { getTagServiceId, getListFavsServices, getMessageFavServices } from '../../../store/selectors/paymentsSelectors'
import { ClaroModalCustom, ClaroCardSimple, ClaroModalCardOk, ClaroTextGeneral, ClaroLinkButton, ClaroButton, ClaroImageBanner } from "@claropay/shared";
import FavoriteElement from '../../atoms/FavoriteElement/';
import ClaroImage from '../../molecules/ClaroImage';
import ModalCardLoader from "../ModalCardLoader/index.js";
import { getMessage } from "../../organisms/utils.js";
import { executeTaggeo } from "../../../store/actions";
import ToolTipTelcelAvisos from '../../organisms/TooltipTelcelAvisos';

const ContainerListFavs = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`
const ButtonClose = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
  background-color: transparent;
`

const SubtitleServiceFavs = styled.h2`
  font-size: 14px !important;
  font-family: Roboto !important;
  color: #848484;
  text-align: left;
  align-self: flex-start;
  margin-bottom: 24px !important;
`
const ListServiceFavs = styled.div`
  height: 59vh;
  overflow: auto;
  color: black;
  padding: 2px 2px 0;
  margin: 0;
  align-self: stretch;
`
const LogoServiceFavs = styled.img`
  margin-top: 16px;
  margin-bottom: 24px;
`

export default class HasFavoriteServices extends Component {
  constructor (props) {
    super(props);
    this.state = {
      isOpenListFavs: true,
      isDeletedFavorite: false,
      isEditFavorite: false,
      idFavServiceCurrent: null,
      accountServiceCurrent:'',
      aliasCurrent:'',
      listFavs: [],
      cpMessage: "CP0529"
    }
}

  componentDidMount() {
    const{executeTaggeo, tagServiceId, getFavoritosRef, getMessagesFavoritesServices, listFavServices} = this.props;

    getFavoritosRef('findFavoriteMicroApp', tagServiceId);
    getMessagesFavoritesServices('PagoServicios');
    this.setState({listFavs: listFavServices})

    if(listFavServices && (listFavServices.length === 0)){ // Si la lista de servicios guardados está vacía cambiar mensaje a "Sin servicios guardados"
      this.setState({cpMessage: "CP0530"});
      executeTaggeo({
        action: "View alert",
        step: "Formulario de pago",
        alert_id: "Sin servicios guardados",
        service: tagServiceId,
      });
    }else{
      executeTaggeo({
        action: "View",
        step: "Servicios guardados",
        service: tagServiceId,
      });
    }
    
  }

  componentDidUpdate(prevProps){
    const {hasFavsError, errorCodeFavs, executeTaggeo, tagServiceId, listFavServices} = this.props;

    if((hasFavsError !== undefined) && (errorCodeFavs !== prevProps.errorCodeFavs)){ // Si hay error 
      this.setState({cpMessage: errorCodeFavs});

      if(errorCodeFavs === "CP0525"){ // Si no se puede eliminar el servicio guardado
        executeTaggeo({
          action: "View alert",
          step: "Formulario de pago",
          alert_id: "Imposible eliminar servicio guardado",
          service: tagServiceId,
        });
      }
    }

    if(prevProps.listFavServices !== this.props.listFavServices){ // Si se actualiza la lista de servicios guardados
      if(listFavServices && (listFavServices.length === 0)){ // Si la lista de servicios guardados está vacía cambiar mensaje a "Sin servicios guardados"
        this.setState({cpMessage: "CP0530"});
      }
    }
  }

  openSnackBar = () => {  // Abre snackbar de confirmación de eliminación de servicio guardado
    const parameters = `{"show": true,"name": "snackbarConfirmDeleteFav","cp": "CP0527","flow": "PagoServicios"}`;
		const url = '{"app": "startEventNoClose","to": "showGenericSnackBack", "parameters": ' + JSON.stringify(parameters) +	"}";    
		sdkclaro.getInstance().openNative(url);
  }

  closeModalListFavs = (e) => { // Cierra modal de lista servicios guardados
    this.setState({ isOpenListFavs: false });
  };

  openDeleteFavoriteService = (lidFavorite) => { // Abre modal de confirmación de eliminación de servicio guardado
    const {executeTaggeo, tagServiceId} = this.props;

    this.setState({cpMessage: "CP0524"});
    this.setState({ isOpenListFavs: false });
    this.setState({ isDeletedFavorite: true });
    this.setState({ idFavServiceCurrent: lidFavorite });
    executeTaggeo({
      action: "View alert",
      step: "Formulario de pago",
      alert_id: "Seguro de eliminar servicio guardado",
      service: tagServiceId,
    });
  }

  closeDeleteFavoriteService = () => {  // Cierra modal de confirmación de eliminación de servicio guardado
    const {executeTaggeo, tagServiceId} = this.props;

    this.setState({ isDeletedFavorite: false });
    this.setState({ isOpenListFavs: true }); 
    executeTaggeo({
      action: "Click alert Cancelar",
      step: "Formulario de pago",
      alert_id: "Seguro de eliminar servicio guardado",
      service: tagServiceId,
    });
  }

  deleteFavoriteService = () => {  // Elimina servicio guardado
    const {executeTaggeo, tagServiceId, deleteFavoritesRef} = this.props;
    const {idFavServiceCurrent} = this.state;

    executeTaggeo({
      action: "Click alert Eliminar",
      step: "Formulario de pago",
      alert_id: "Seguro de eliminar servicio guardado",
      service: tagServiceId,
    });

    const lidFavorite = idFavServiceCurrent;
    deleteFavoritesRef(lidFavorite);

    this.setState({ isDeletedFavorite: false });

    setTimeout(() => {
      this.deleteComplete();
    }, 800);

    this.setState({ idFavServiceCurrent: null });
  }
  
  deleteComplete = () => {
    const {handleSetFavValue, hasFavsError,closeModalFavoriteServices} = this.props;

    if(hasFavsError === undefined){
      handleSetFavValue('')
      this.openSnackBar();
      closeModalFavoriteServices();
    }
  }

  openEditFavoriteService = (lidFavorite,accountService, alias) => {  // Abre modal de edición de servicio guardados
    const {executeTaggeo, tagServiceId} = this.props;

    this.setState({ isOpenListFavs: false });
    this.setState({ isEditFavorite: true});
    this.setState({ 
      idFavServiceCurrent: lidFavorite,
      accountServiceCurrent: accountService,
      aliasCurrent: alias,
    });
  }

  closeEditFavoriteService = () => { // Cierra modal de edición de servicio guardados
    const {closeModalFavoriteServices} = this.props; 
    const {accountServiceCurrent} = this.state;
    // this.setState({isEditFavorite: false});
    closeModalFavoriteServices();
  }

  handleClickCloseModal = () => { // Cierra tootltip "no hay servicios guardados"
    const {executeTaggeo, tagServiceId, closeModalFavoriteServices} = this.props;
    const {cpMessage} = this.state;

    if(cpMessage === "CP0530"){
      executeTaggeo({
        action: "Click alert Entendido",
        step: "Formulario de pago",
        alert_id: "Sin servicios guardados",
        service: tagServiceId,
      });
    }
    closeModalFavoriteServices();
  }

  handleClickDeleteCloseModal = () => { //
    const {executeTaggeo, tagServiceId, closeModalFavoriteServices} = this.props;
    const {cpMessage} = this.state;
    if(cpMessage === "CP0525"){
      executeTaggeo({
        action: "Click alert Entendido",
        step: "Formulario de pago",
        alert_id: "Imposible eliminar servicio guardado",
        service: tagServiceId,
      });
    }
    closeModalFavoriteServices();
  }

  render() {
    const { isOpenListFavs,isDeletedFavorite,cpMessage,isEditFavorite, idFavServiceCurrent,aliasCurrent,accountServiceCurrent } = this.state;
    const { listMessagesFavServices,mediaService,closeModalFavoriteServices, isFavoriteServices, isContainerTelcel,hasFavsError,listFavServices,isLoadingGetFavServices, executeTaggeo, tagServiceId, handleSetFavValue } = this.props;
 
    let messageInformation = { data: {} };
    if (listMessagesFavServices.length !== 0) {
      messageInformation = getMessage(listMessagesFavServices, cpMessage);
    }
   
      if(isEditFavorite){
        return(
          <CreateFavoriteService
            isFavoriteServices={isEditFavorite}
            accountService={accountServiceCurrent}
            lidFavorite={idFavServiceCurrent}
            alias={aliasCurrent}
            isContainerTelcel={isContainerTelcel}
            closeModalFavoriteServices={this.closeEditFavoriteService}
            executeTaggeo={executeTaggeo}
          />  
        )
      }else{
        if(isLoadingGetFavServices){
          return(
            <ModalCardLoader isOpen={isLoadingGetFavServices} />
          )
        }else{
        return (
          <>        
          {(listFavServices && listFavServices.length !== 0 && listFavServices[0].isActive) && hasFavsError === undefined ? 
          (
            <>
              <ClaroModalCustom isOpen={isOpenListFavs} backgroundColor={'rgba(0, 0, 0, 0.65)'}>
                <ClaroCardSimple
                  backgroundColor='#f6f6f6'
                  borderRadius='15px 15px 0px 0px'
                  margin='0px'
                  height='100%'
                  style={{ width:"100%",	marginBottom: '-70%' }}
                  fadeIn='fadeIn'
                  fadeInTime='1s'
                  cubicBezier='cubic-bezier(0.9, 0, 0.9, 1)'
                  addCloseEfect = {false}
                >
                  <ContainerListFavs>
                    <ButtonClose onClick={() => closeModalFavoriteServices()}>
                      <img 
                        src={isContainerTelcel ? "/images/icono_salir_contenedor.png" : "/images/icono_salir.svg"}
                        width={isContainerTelcel ? "24" : "16"}
                        height={isContainerTelcel ? "24" : "16"} 
                      />
                    </ButtonClose>
                    {tagServiceId === 'amigopaguitos' ? 
                      <LogoServiceFavs
                        src={this.props.configImgService}
                        width="45%"
                        height="auto"
                        alt=""
                      /> 

                      :
                      <ClaroImage {...mediaService.logo.data} />
                    }
                    <SubtitleServiceFavs>Tus servicios guardados</SubtitleServiceFavs>
                  
                    <ListServiceFavs>
                      {(listFavServices && mediaService !== undefined) && listFavServices.map((fav, index) => {
                        return <FavoriteElement 
                                key={index} 
                                fav={fav} 
                                mediaService={mediaService} 
                                openDeleteFavoriteService={this.openDeleteFavoriteService} 
                                openEditFavoriteService={this.openEditFavoriteService} 
                                handleSetFavValue={handleSetFavValue} 
                                closeModalFavoriteServices={closeModalFavoriteServices} 
                                executeTaggeo={executeTaggeo} tagServiceId={tagServiceId} 
                              />
                      }
                      )}
                    </ListServiceFavs>
                  </ContainerListFavs>
                  
                </ClaroCardSimple>
              </ClaroModalCustom>
  
              {isDeletedFavorite && (
                <ClaroModalCustom isOpen={isDeletedFavorite} backgroundColor={'rgba(0, 0, 0, 0.65)'}>
                  <ClaroCardSimple
                    css
                    backgroundColor='#ffffff'
                    borderRadius='6px'
                    margin='0px 16px'
                    padding='16px 11vw'
                    height='auto'
                    textAlign='center'
                  >
                    <section>
                      <ClaroImageBanner 
                        imageModal
                        margin='-43px 0 30px 0'
                      >
                        <img
                          width='62px' 
                          height='62px' 
                          src={messageInformation.data.icon} 
                        />
                      </ClaroImageBanner>
                      <ClaroTextGeneral
                        textmodal1
                        fontFamily='NunitoBold'
                        fontWeight='700'
                        fontSize='20px'
                        color='#000'
                        textAlign='center'
                        margin= '0px 0px 16px 0px !important'
                      >
                        {messageInformation.data.subject}
                      </ClaroTextGeneral>
                      <ClaroButton
                        backgroundColor='#000'
                        activeBackgroundButton='none'
                        hoverBackgroundButton='none'
                        color='#fff'
                        fontFamily='RobotoBold'
                        fontWeight='700'
                        fontSize='4.05vw !important'
                        lineHeight='11.5vw'
                        borderRadius='50px'
                        width='61.111vw'
                        height='11.4667vw'
                        margin='0 auto 3vh auto'
                        display='block'
                        onClick={() => {
                          this.deleteFavoriteService();
                        }}
                      >
                        {messageInformation.data.buttons[0]}
                      </ClaroButton>
                      <ClaroLinkButton
                        textSize= "16px"
                        textColor= "#000"
                        btnBackground= "none"
                        activeOpacity= "1"
                        textAlign= "center"
                        fontWeight="700"
                        textDecoration="underline"
                        fontFamily="RobotoBold"
                        textTransform= "capitalize"
                        lineHeight= "24px"
                        onClick={() => {
                          this.closeDeleteFavoriteService();
                        }}
                      >
                        {messageInformation.data.buttons[1]}
                      </ClaroLinkButton>
                    </section>
                  </ClaroCardSimple>
                </ClaroModalCustom>
              )}  
            </>
          ) : hasFavsError ? (
            <ClaroModalCardOk 
              isOpen={isFavoriteServices} 
              heightImg='62px'
              widthImg='62px'
              srcImage={messageInformation.data.icon ? messageInformation.data.icon : ""}
              backgroundColor="rgba(0,0,0,0.65)"
              paddingCard="16px 11vw;"
              borderRadiusCard='5px'
              text={messageInformation.data.subject ? messageInformation.data.subject : ""}
              fontFamilyTitle='NunitoBold'
              fontSizeTitle='20px'
              textdetail={messageInformation.data.message ? messageInformation.data.message : ""}
              fontSizeDetail='16px'
              fontFamilyDetail='Roboto'
              buttontext={messageInformation.data.buttons ? messageInformation.data.buttons[0] : ""}
              colorButton='#fff'
              backgroundColorButton='#000'
              activeBackgroundButton='none'
              hoverBackgroundButton='none'
              fontSizeButton='4.05vw !important'
              onClickImg=""
              textAlignLinkButton="center"
              textDecorationLinkButton="underline"
              fontWeightLinkButton="bold"
              fontFamilyLinkButton ="Roboto"
              onclickModal={() => this.handleClickDeleteCloseModal()}
            /> 
          ): 
            <ToolTipTelcelAvisos 
              tooltipInformation={messageInformation}
              isOpen={isFavoriteServices}
              titleFontFamily='NunitoBold'
              titleFontSize='18px'
              titleMargin='5% 48px 5% 48px'
              handleNextAction={
                () => {
                  this.handleClickCloseModal()
                }
              }
            />
            }
          </>
        );
      }
      
    }
  }
}

function mapStateToProps(state) {
  const {payments,favoritesRefReducer} = state;
  const tagServiceId = getTagServiceId(payments);
  const listFavServices = getListFavsServices(favoritesRefReducer);
  const listMessagesFavServices = getMessageFavServices(favoritesRefReducer);
  return {
    favoriteServices: state,
    tagServiceId,
    listFavServices,
    listMessagesFavServices,
    isLoadingGetFavServices: state.favoritesRefReducer.isLoading,
    hasFavsError: state.favoritesRefReducer.ResponseError,
    errorCodeFavs: state.favoritesRefReducer.CodeError,
    mediaService: state.payments.PAYMENT_SERVICE_CONF.services[0].serviceData.generic,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getFavoritosRef,
      deleteFavoritesRef,
      getMessagesFavoritesServices,
      executeTaggeo,
    },
    dispatch,
  );
}

HasFavoriteServices = connect(
  mapStateToProps,
  mapDispatchToProps
)(HasFavoriteServices);